import { useState, useEffect } from "react";
import GroupLeaderSection from "./GroupLeaderSection.jsx";
import EmergencyContactSection from "./EmergencyContactSection.jsx";
import PassengersSection from "./PassengersSection.jsx";
import TransferSection from "./TransferSection.jsx";
import MedicalSection from "./MedicalSection.jsx";
import FoodSection from "./FoodSection.jsx";
import DietarySection from "./DietarySection.jsx";
import DrinksSection from "./DrinksSection.jsx";
import ActivitiesSection from "./ActivitiesSection.jsx";
import CrewSection from "./CrewSection.jsx";
import { useTranslation } from 'react-i18next';

import Swal from 'sweetalert2';
import axios from 'axios';

const initialState = {
    groupLeader: {
        fullName: "",
        address: "",
        phone: "",
        mobile: "",
        email: "",
    },

    emergencyContact: {
        fullName: "",
        phone: "",
        mobile: "",
        email: "",
    },

    passengers: [
        {
            firstName: "",
            lastName: "",
            birthDate: "",
            passport: "",
            nationality: "",
        },
    ],

    transfers: {
        pickupLocation: "",

        arrival: {
            date: "",
            time: "",
            airport: "",
            flightNumber: "",
            hotel: "",
            hotelPhone: "",
        },

        departure: {
            date: "",
            time: "",
            airport: "",
            flightNumber: "",
            hotel: "",
            hotelPhone: "",
        },
    },

    medicalInformation: "",

    specialOccasion: "",

    food: {

        cuisine: "",

        otherCuisine: "",

        products: {

            beef: "",
            lamb: "",
            veal: "",
            chicken: "",
            lowFat: "",
            fish: "",
            prawns: "",
            seafood: "",
            salads: "",
            vegetables: "",
            fruit: "",
            desserts: "",
            barbecue: "",
            stews: ""

        },

        comments: "",

        dinner: {

            onBoard: false,
            onShore: false

        }

    },

    dietary: {

        specialDiet: {
            enabled: false,
            details: ""
        },

        allergies: {
            enabled: false,
            details: ""
        },

        dislikes: {
            enabled: false,
            details: ""
        }

    },

    drinks: "",

    activities: {

        swimming: "",
        snorkel: "",
        diving: "",
        jetSki: "",
        fishing: "",
        reading: "",
        sunbathing: "",
        beaches: "",
        shopping: "",
        nightlife: "",
        other: "",
        otherActivities: ""

    },

    crew: {

        interaction: "",
        comments: ""

    },

    personalNotes: "",
};

export default function GuestPreferencesForm({ reserva, lang }) {

    const { t } = useTranslation();

    let token = document.getElementById('meta_token').getAttribute('content');

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [formData, setFormData] = useState(initialState);

    const maxPassengers = reserva.adultos + reserva.ninos;

    const passengersValid = formData.passengers.length === maxPassengers;

    useEffect(() => {
        if (!reserva?.cliente) return;

        setFormData(prev => ({
            ...prev,
            groupLeader: {
                fullName: `${reserva.cliente.nombre} ${reserva.cliente.apellidos}`.trim(),
                address: reserva.cliente.direccion || "",
                phone: reserva.cliente.telefono || "",
                mobile: reserva.cliente.movil || "",
                email: reserva.cliente.email || "",
            }
        }));
    }, [reserva]);

    const handleGroupLeaderChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            groupLeader: {
                ...prev.groupLeader,
                [name]: value,
            },
        }));
    };

    const handleEmergencyChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            emergencyContact: {
                ...prev.emergencyContact,
                [name]: value,
            },
        }));
    };

    const onPassengerChange = (index, field, value) => {
        setFormData((prev) => {
            const passengers = [...prev.passengers];
            passengers[index][field] = value;

            return {
                ...prev,
                passengers,
            };
        });
    };

    const addPassenger = () => {

        if (formData.passengers.length >= (reserva.adultos + reserva.ninos)) {
            return;
        }

        setFormData((prev) => ({
            ...prev,
            passengers: [
                ...prev.passengers,
                {
                    firstName: "",
                    lastName: "",
                    birthDate: "",
                    passport: "",
                    nationality: "",
                },
            ],
        }));
    };

    const removePassenger = (index) => {
        setFormData((prev) => ({
            ...prev,
            passengers: prev.passengers.filter((_, i) => i !== index),
        }));
    };

    const onPickupChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            transfers: {
                ...prev.transfers,
                pickupLocation: value,
            },
        }));
    };

    const onArrivalChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            transfers: {
                ...prev.transfers,
                arrival: {
                    ...prev.transfers.arrival,
                    [field]: value,
                },
            },
        }));
    };

    const onDepartureChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            transfers: {
                ...prev.transfers,
                departure: {
                    ...prev.transfers.departure,
                    [field]: value,
                },
            },
        }));
    };

    const onMedicalChange = (value) => {
        setFormData(prev => ({
            ...prev,
            medicalInformation: value
        }));
    };

    const onOccasionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            specialOccasion: value
        }));
    };

    const onCuisineChange = (value) => {
        setFormData(prev => ({
            ...prev,
            food: {
                ...prev.food,
                cuisine: value
            }
        }));
    };

    const onCuisineTypeChange = (value) => {
        setFormData(prev => ({
            ...prev,
            food: {
                ...prev.food,
                otherCuisine: value
            }
        }));
    };

    const onProductChange = (product, value) => {

        setFormData(prev => ({
            ...prev,
            food: {
                ...prev.food,
                products: {
                    ...prev.food.products,
                    [product]: value
                }
            }
        }));

    };

    const onCommentsChange = (value) => {

        setFormData(prev => ({
            ...prev,
            food: {
                ...prev.food,
                comments: value
            }
        }));

    };

    const onDinnerChange = (field, value) => {

        setFormData(prev => ({
            ...prev,
            food: {
                ...prev.food,
                dinner: {
                    ...prev.food.dinner,
                    [field]: value
                }
            }
        }));

    };

    const onDietaryChange = (group, field, value) => {

        setFormData(prev => ({
            ...prev,
            dietary: {
                ...prev.dietary,
                [group]: {
                    ...prev.dietary[group],
                    [field]: value
                }
            }
        }));

    };

    const onDrinksChange = value => {

        setFormData(prev => ({

            ...prev,
            drinks: value

        }));

    };

    const onActivityChange = (activity, value) => {

        setFormData(prev => ({

            ...prev,
            activities: {
                ...prev.activities,
                [activity]: value
            }

        }));

    };

    const onOtherActivitiesChange = value => {

        setFormData(prev => ({

            ...prev,
            activities: {
                ...prev.activities,
                otherActivities: value
            }

        }));

    };

    const onCrewInteraction = value => {

        setFormData(prev => ({

            ...prev,
            crew: {
                ...prev.crew,
                interaction: value
            }

        }));

    };

    const onCrewComments = value => {

        setFormData(prev => ({

            ...prev,
            crew: {
                ...prev.crew,
                comments: value
            }

        }));

    };

    const onNotesChange = value => {

        setFormData(prev => ({

            ...prev,
            personalNotes: value

        }));

    };

    const [loading, setLoading] = useState(false);

    const trataFormulario = async (e) => {

        e.preventDefault();

        if (!e.target.checkValidity()) {
            e.target.reportValidity();
            return;
        }

        if (formData.passengers.length !== maxPassengers) {
            alert(
                `Debe introducir los datos de los ${maxPassengers} pasajeros.`
            );
            return;
        }

        //alert("Enviando formulario");

        const url = "/recepcion_preferencias";

        setLoading(true);

        try {
            const response = await axios.post(
                url,
                {
                    preferencias: formData,
                    lang: lang,
                    reserva: reserva.id
                },
                {
                    headers: {
                        'content-type': 'text/json',
                        'X-CSRF-TOKEN': token
                    }
                }
            );
            console.log(response);

            if (response.data.type === "error") {
                Swal.fire({
                    title: "KO!",
                    html: `${t('Preferencias no guardadas')}`,
                    timer: 1500,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                });
            } else {
                Swal.fire({
                    title: "OK!",
                    html: `${t('Preferencias guardadas')}`,
                    timer: 1500,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                });
            }
        }
        catch (error) {
            console.error(error);

            Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error al guardar las preferencias.",
                icon: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    const formatearFecha = (fecha) => {
        return new Date(fecha)
            .toLocaleDateString("es-ES");
    };

    return (
        <>
            <section className="u-clearfix u-image u-shading u-valign-middle-lg u-valign-middle-sm u-section-1" id="sec-5458" data-image-width="2527" data-image-height="1420" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)), url(/images/web/onboard2/Freedom-lifestyle156.jpg)" }}>
                <h1 className="u-align-center u-custom-font u-text u-text-default u-text-white u-title u-text-1 fontmontserrat">
                    {t("Lista de preferencias de los huéspedes")}
                </h1>
                <p className="u-align-center u-custom-font u-text u-text-default u-text-white u-title u-text-2 fontmontserrat">
                    {t("Para ayudarnos a ofrecerle el crucero perfecto, le rogamos que dedique unos minutos a completar este cuestionario.")}
                    <br />
                    {t("Esta información será transmitida a su tripulación y les permitirá garantizar que su experiencia de chárter sea la mejor posible.")}
                    <br />
                    {t("Con el fin de que la tripulación pueda preparar adecuadamente su viaje, le agradeceríamos que nos devolviera este formulario lo antes posible.")}
                </p>
            </section>

            <section className="u-clearfix u-container-align-center u-grey-10 u-section-2" id="sec-5506">

                <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs">
                    <h1 className="u-align-center fontmontserrat">{reserva.propiedad.nombre}</h1>
                    <h2 className="u-align-center fontmontserrat">{formatearFecha(reserva.inicio)} - {formatearFecha(reserva.final)}</h2>
                </div>
                <form onSubmit={trataFormulario}>

                    {/*** Lider y emergencias */}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-30 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <input type="hidden" name="lang" id="idioma" value={lang.toString().toUpperCase()} />

                                                    <GroupLeaderSection
                                                        data={formData.groupLeader}
                                                        onChange={handleGroupLeaderChange}
                                                        lang={lang}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="u-align-center u-container-align-center u-container-style u-layout-cell u-radius-50 u-shape-round u-size-30 u-white u-layout-cell-2" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <EmergencyContactSection
                                                        data={formData.emergencyContact}
                                                        onChange={handleEmergencyChange}
                                                        lang={lang}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    {/*** Pasajeros */}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-60 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <PassengersSection
                                                        passengers={formData.passengers}
                                                        onPassengerChange={onPassengerChange}
                                                        addPassenger={addPassenger}
                                                        removePassenger={removePassenger}
                                                        lang={lang}
                                                        personas={reserva.adultos + reserva.ninos}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    {/*** Tranfer y informe medico */}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-60 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <TransferSection
                                                        transfers={formData.transfers}
                                                        onPickupChange={onPickupChange}
                                                        onArrivalChange={onArrivalChange}
                                                        onDepartureChange={onDepartureChange}
                                                        lang={lang}
                                                    />

                                                    <MedicalSection
                                                        medicalInformation={formData.medicalInformation}
                                                        specialOccasion={formData.specialOccasion}
                                                        onMedicalChange={onMedicalChange}
                                                        onOccasionChange={onOccasionChange}
                                                        lang={lang}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    {/*** Alimentación y dieta */}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-60 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <FoodSection
                                                        food={formData.food}
                                                        onCuisineChange={onCuisineChange}
                                                        onCuisineTypeChange={onCuisineTypeChange}
                                                        onProductChange={onProductChange}
                                                        onCommentsChange={onCommentsChange}
                                                        onDinnerChange={onDinnerChange}
                                                        lang={lang}
                                                    />
                                                    <DietarySection
                                                        dietary={formData.dietary}
                                                        onDietaryChange={onDietaryChange}
                                                        lang={lang}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    {/*** bebidas y acfividades */}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-30 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <DrinksSection
                                                        drinks={formData.drinks}
                                                        onChange={onDrinksChange}
                                                        lang={lang}
                                                        manual={reserva.propiedad.documento_manual}
                                                        idpropiedad={reserva.propiedad.id}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="u-align-center u-container-align-center u-container-style u-layout-cell u-radius-50 u-shape-round u-size-30 u-white u-layout-cell-2" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <ActivitiesSection
                                                        data={formData.activities}
                                                        onActivityChange={onActivityChange}
                                                        onOtherActivitiesChange={onOtherActivitiesChange}
                                                        lang={lang}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    {/*** Tripulación y botón*/}
                    <div className="mt-20 u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                        <div className="data-layout-selected u-clearfix u-expanded-width u-gutter-26 u-layout-wrap u-layout-wrap-1">
                            <div className="u-layout">
                                <div className="u-layout-row">
                                    <div className="u-align-center u-container-align-center-lg u-container-align-center-xl u-container-style u-layout-cell u-radius-50 u-shape-round u-size-60 u-white u-layout-cell-1" data-animation-out="0">
                                        <div className="u-container-layout u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-valign-top-xl u-container-layout-5">
                                            <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-form">
                                                <div className="u-clearfix u-form-spacing-32 u-form-vertical u-inner-form" style={{ padding: "25px" }}>
                                                    <CrewSection
                                                        crew={formData.crew}
                                                        notes={formData.personalNotes}
                                                        onCrewInteraction={onCrewInteraction}
                                                        onCrewComments={onCrewComments}
                                                        onNotesChange={onNotesChange}
                                                        lang={lang}
                                                    />

                                                    <button
                                                        type="submit"
                                                        className="u-active-palette-2-light-1 u-border-none u-btn u-btn-round u-button-style u-custom-color-5 u-hover-custom-color-7 u-radius-50 u-btn-1 fontmontserrat"
                                                        style={{ marginLeft: "auto", marginRight: "auto" }}
                                                    >
                                                        {t("Guardar formulario")}
                                                    </button>
                                                    <p className="u-align-center u-form-group u-form-text u-label-none u-text u-text-6 fontmontserrat">
                                                        {t("¡LES DESEAMOS UNA EXPERIENCIA INOLVIDABLE!")}<br />
                                                        {t("¡HASTA PRONTO!")}<br />
                                                        {t("Equipo de OnBoard Holidays")}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </form>
            </section>

            {loading && (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            )}
        </>
    );
}
